<template>
    <div class="table-container">
    <ods-module class="table-content" style="padding-top: 20px; border-radius: 5px;">
       <ods-module>
        <div slot="header" class="clearfix" style="position: relative;">
            <ventana-usuario @mostrarVentanaUsuario="mostrarVentanaUsuarioTabla" :profiles="QRprofiles"></ventana-usuario>
        </div>
        <div>
          <div v-if="mostrarTabla">
            <ods-table
            v-loading="loadingTable"
            :data="tableDataRendered"
            style="width: 100%"
            @row-click="openModifyModalRow"
            highlight-current-row
            reserve-selection>
                <ods-table-column
                prop="usuario"
                label="Usuario"
                min-width="60"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="nomcompleto"
                label="nombre y apellido"
                min-width="100"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="desperfil"
                label="perfil"
                min-width="80"
                sortable>
                </ods-table-column>
                <ods-table-column
                prop="holding"
                label="holding"
                min-width="120"
                sortable>
                  <template slot-scope="scope">
                    <ods-row>
                      <span v-if="scope.row.holding != '-'">
                        {{ scope.row.holding }} - {{ scope.row.desholding }}
                      </span>
                      <span v-else >
                         -
                      </span>
                    </ods-row>
                  </template>
                </ods-table-column>
                <ods-table-column
                prop="cadena_comercial"
                label="cadena"
                min-width="120"
                sortable>
                  <template slot-scope="scope">
                    <ods-row>
                      <span v-if="scope.row.cadena_comercial">
                        {{ scope.row.cadena_comercial }} - {{ scope.row.descadena }}
                      </span>
                      <span v-else >
                         -
                      </span>
                    </ods-row>
                  </template>
                </ods-table-column>
                <ods-table-column
                prop="comercio"
                label="comercio"
                min-width="120"
                sortable>
                  <template slot-scope="scope">
                    <ods-row>
                      <span v-if="scope.row.comercio">
                        {{ scope.row.comercio }} - {{ scope.row.descomercio }}
                      </span>
                      <span v-else >
                         -
                      </span>
                    </ods-row>
                  </template>
                </ods-table-column>
                <ods-table-column
                prop="email"
                label="correo electronico"
                align="center"
                min-width="150"
                header-align="center"
                sortable
                style="margin-left: 0%;">
                </ods-table-column>
                <ods-table-column
                prop="object"
                label="ACCIONES"
                align="right"
                min-width="60">
                  <template slot-scope="scope">
                    <ods-row>
                      <ods-actions-menu
                        customClass="myClass"
                        :icon=icon
                        width="144"
                        popoverPosition="left-end"
                        mobilePopoverPosition="bottom-end"
                        :boundariesElement="boundariesElement"
                        :onShowEvent="true"
                        @show="onShow">
                          <ul>
                            <li class="pointer" @click="openModifyModal(scope.$index, scope.row)">
                              <span class="ods-icon-audit" size="mini"></span>Ver detalle
                            </li>
                            <li v-if="scope.row.editable" class="pointer ods-mt-4" @click="openDeleteModal(scope.$index, scope.row)">
                              <span class="ods-icon-delete" size="mini">
                              </span>Eliminar
                            </li>
                          </ul>
                      </ods-actions-menu>
                    </ods-row>
                  </template>
                </ods-table-column>
            </ods-table>
          </div>
          <div v-else style="text-align: center; margin-top: 30px;">
            <ods-row>
              <img :src="require('@/assets/icons/pic_map.svg')">
            </ods-row>
            <ods-row>
              <span class="todas-las-rutas-de-e">Sin resultados de búsqueda</span>
            </ods-row>
          </div>
        </div>
        <div class="footer">
          <paginator
            :isNextPage="indMasDatos"
            :currentPage="currentPage"
            @buttonPrevAction="getPrevPage"
            @buttonNextAction="getNextPage">
          </paginator>
          <!-- <ods-pagination class="footer__page"
          :page-size = listUser.length
          layout="prev, pager, next"
          :total='totalData'
          style="text-align:right; padding: 20px;"
          @size-change='handleSizeChange'
          @current-change="handleCurrentChange">
          </ods-pagination> -->
        </div>
    </ods-module>
    </ods-module>
         <dialog-generic-error
          :message="errorMessage"
          :dialogError="dialogError"
          :before-close-fn="handleCloseSession"
          @dialogClosed="closeDialogError($event)">
          </dialog-generic-error>
            <ventana-borrar-usuario
              :isVisible="dialogVisible"
              :rowDelete="rowSeleccionada"
              :toggleVisible="toggleDeleteUser"
              @closingDialog="dialogVisible = $event"
              @actulizarList="getData()"
              >
            </ventana-borrar-usuario>
            <ventana-modificar-usuario
              :filtradoComercio="false"
              :isVisible="dialogModificarVisible"
              :rowModify="rowSeleccionada"
              :toggleVisible="toggleModifyUser"
              @closingDialog="dialogModificarVisible = $event">
            </ventana-modificar-usuario>

  </div>
</template>

<script>
import VentanaUsuario from '@/components/dialogs/VentanaUsuario'
import VentanaBorrarUsuario from '@/components/dialogs/VentanaBorrarUsuario'
import VentanaModificarUsuario from '@/components/dialogs/VentanaModificarUsuario'
import DialogGenericError from '@/components/dialogs/DialogGenericError'
import Paginator from '@/components/shared/Paginator'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      defaultParams: {},
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      // itemsPerPage: 30,
      value: '',
      boolean: false,
      // totalpaginas: 0,
      searched: '',
      dialogVisible: false,
      dialogModificarVisible: false,
      rowSeleccionada: '',
      isVisible: false,
      dialogError: false,
      hasErrors: false,
      errorMessage: '',
      imagen: false,
      mostrarTabla: true,
      QRprofiles: [],
      icon: 'overflow-menu',
      popoverPosition: 'left-end',
      mobilePopoverPosition: 'bottom-end',
      boundariesElement: '#root',
      myClass: 'myClass',
      actionMenuRow: false
      // currentPageData: 1
      // tableData: this.data
    }
  },

  watch: {
    formatNomApe (val) {
      if (val) {
        val.forEach(element => {
          element.nomcompleto = (element.nombre.toUpperCase()) + ' ' + (element.apelli1.toUpperCase()) + ' ' + (element.apelli2.toUpperCase())
          element.usuario = element.usuario.toUpperCase()
        })
        this.tableDataRendered = val
      }
    }
  },

  mounted () {
    if (this.configFile.endpoints) {
      this.getInitialData()
    }
    // this.$store.dispatch('listUsers').then(r => {
    //   if (!r || (r && r.error === true)) {
    //     this.displayErrorDialog(r.data.runServiceResponse.return.descRetorno)
    //   } else {
    //     if (r.vacio === true) {
    //       this.mostrarTabla = false
    //     } else {
    //       this.executeListProfile()
    //       this.mostrarTabla = true
    //       this.tableData = r
    //       this.data = this.tableData
    //     }
    //   }
    // }).catch(e => {
    //   this.executeListProfile()
    //   console.error('Error in list Users - App', e)
    // })
    // this.handlePagination()
  },

  computed: {
    ...mapGetters({
      listUser: 'getlistUsersData',
      totalData: 'getTotalRegistros',
      configFile: 'configFile'
    }),

    formatNomApe () {
      return this.listUser
    }
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado de Usuarios
      await this.$store.dispatch('listUsers', params).then(res => {
        this.loadingTable = false
        if (!res || (res && res.error === true)) {
          this.displayErrorDialog(res.data.runServiceResponse.return.descRetorno)
        } else {
          if (res.vacio === true) {
            this.mostrarTabla = false
          } else {
            this.executeListProfile()
            this.mostrarTabla = true
            if (res.registros) {
              this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
              this.tableDataRendered = this.tableData
            } else {
              this.tableData = null
              this.tableDataRendered = this.tableData
            }
            this.currentPage = res.pantPagina
            this.indMasDatos = res.indMasDatos
            this.paginationParams = {
              claveInicio: res.claveInicio,
              claveFin: res.claveFin
            }
          }
        }
      }).catch(e => {
        this.executeListProfile()
        console.error('Error in list Users - App', e)
      })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    // handleSizeChange (val) {
    //   this.itemsPerPage = val
    //   this.handlePagination()
    // },

    // handleCurrentChange (val) {
    //   this.currentPageData = val
    //   this.handlePagination()
    // },

    // handlePagination (arr) {
    //   if (Array.isArray(this.data)) {
    //     this.tableData = this.data.slice(
    //       (this.currentPageData - 1) * this.itemsPerPage,
    //       this.currentPageData * this.itemsPerPage)
    //   }
    // },

    openDeleteModal (index, row) {
      this.rowSeleccionada = row
      this.toggleDeleteUser()
    },
    openModifyModal (index, row) {
      this.rowSeleccionada = row
      this.toggleModifyUser()
    },
    openModifyModalRow (index, row) {
      if (this.actionMenuRow === false) {
        this.rowSeleccionada = index
        this.toggleModifyUser()
        this.actionMenuRow = false
      }
      this.actionMenuRow = false
    },
    toggleDeleteUser () {
      if (this.dialogVisible) {
        this.dialogVisible = false
      } else {
        this.dialogVisible = true
      }
    },
    toggleModifyUser () {
      if (this.dialogModificarVisible) {
        this.dialogModificarVisible = false
      } else {
        this.dialogModificarVisible = true
      }
    },
    onShow () {
      this.actionMenuRow = true
    },

    executeListProfile () {
      this.$store.dispatch('listProfile')
        .then((res) => {
          this.QRprofiles = res
        })
    },

    handleCloseSession () {
      this.$store.dispatch('logout')
    },
    closeDialogError (e) {
      this.dialogError = e
      this.handleCloseSession()
    },
    displayErrorDialog (msg) {
      this.errorMessage = `${msg}`
      this.dialogError = true
    },
    mostrarVentanaUsuarioTabla (params) {
      this.mostrarTabla = params
    }
  },

  components: {
    'ventana-usuario': VentanaUsuario,
    'ventana-borrar-usuario': VentanaBorrarUsuario,
    'ventana-modificar-usuario': VentanaModificarUsuario,
    DialogGenericError,
    Paginator
  }
}
</script>

<style lang="scss" scoped>
  .expanded {
    right: 10%;
  }
  .notExpanded {
    right: 2%;
  }
  .todas-las-rutas-de-e {
    height: 24px;
    color: #6E767D;
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    text-align: center;
  }
  .pointer {
    cursor: pointer;
  }
  .bg-01-components-popover-bg {
    height: 100px;
    width: 144px;
    background-color: #FFFFFF;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.1);
  }
  /deep/ .ods-table td {
    padding: 9px 0;
  }
  .myClass{
    width: 144px;
    height: 648px;
    border-radius: 0;
    padding: 0;
  }
  /deep/.ods-actions-menu {
    width: 144px;
    border-radius: 0;
    padding: 0px;
  }
  /deep/ .ods-icon-delete {
    color: red;
  }
</style>
